import { useEffect } from "react";
import { BUSINESS } from "@/lib/site";

const SITE_URL = "https://northworkcyprus.com";

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Lightweight SEO manager: title, description, canonical + LocalBusiness schema.
export function SEO({ title, description, path = "/", schema }) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setCanonical(`${SITE_URL}${path}`);

    const base = {
      "@context": "https://schema.org",
      "@type": "HVACBusiness",
      name: BUSINESS.fullName,
      telephone: BUSINESS.phoneDisplay,
      url: SITE_URL,
      areaServed: { "@type": "City", name: "Paphos" },
      address: { "@type": "PostalAddress", addressLocality: "Paphos", addressCountry: "CY" },
    };
    const merged = schema ? { ...base, ...schema } : base;

    const scriptId = "ld-json-schema";
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(merged);
  }, [title, description, path, schema]);

  return null;
}
